var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-20675.107 -24529.25 9.5 5.785"}},[_c('path',{attrs:{"d":"M-20674.357-24528.5l4 4.286 4-4.286","fill":"none","stroke":"#444","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5","opacity":".54"}})])};var toString = function () {return "/Library/WebServer/Documents/iwp-vue-client/iwp-vue-client/src/assets/down.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.svg
// module id = wgZA
// module chunks = 3